
export const flowColumns = [
    // { field: "userId", headerName: "userId", width: 70 },
    {
        field: "flowName",
        headerName: "ชื่อ",
        width: 250,
    },
    {
        field: "detail",
        headerName: "รายละเอียด",
        width: 250,
    },
     {
        field: "typejournal",
        headerName: "ชื่อเอกสาร",
        width: 200,
    },
];